/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import VisibilityIcon from "@mui/icons-material/Visibility";
import * as MODALS from '../modals';
import { openlightbox } from '../../util/Functions';
import * as API from '../../http/api';
import { useHistory } from 'react-router-dom';
import { AccountStatement } from "../modals";
import { ThemeProvider } from "@mui/material/styles";
import {theme, customStyles} from "../../util/TableStyles"
import { noDataComponent } from "../../util/DataObject"

const ListStpRegister = (props) => {
    const [data, setData] = useState([]);
    const [column, setColumn] = useState([]);
    const [columns, setColumns] = useState([]);
    const history = useHistory()

    useEffect(() => {
        init();
    }, [props.content]);

    const init = async () => {
        setData(JSON.parse(JSON.stringify(props.content)));
        let c = [];
        c.push({
            sortable: true,
            maxWidth: "30px",
            cell: (item, index) => {
                return <div>
                    <a
                        href="#"
                        data-tag="allowRowEvents"
                        onClick={click.bind(this, item)}
                    >
                        <VisibilityIcon />
                    </a>
                </div>
            },
        })

        if(props.config.columns){
            let cols = props.config.columns;
            for(let i = 0; i<cols.length; i++){
                let col = {
                    selector: (row) => row[cols[i]['key']], 
                    name: cols[i]['label'], 
                    sortable: true,
                    maxWidth: '',
                    cell: ''
                }
                c.push(col);
            }
        }

        setColumns(c);
        if(props.content.length == 1){
            await click(props.content[0])
        }
    }

    const click = async (item) => {
        props.updateValueSearch(item.email);
        props.changeLoader(true);
        let data = {
            customerUuid: item.uuid,
        }

        let action = '';
        if(props.config.hasOwnProperty('openModal')){
            action = props.config.openModal;
            data['nextAction'] = props.config.openModal;
        }
        let request = await API.service(action, data, props.pos, props.changeAlert, props.changeLoader, history);
        if (request.status == 200 && request.data.data.response == 'OK') {
            let widg = [];
            widg = request.data.data.widget;
            if (widg[0]?.type === 'stpRegister' && widg[0]?.data?.content) {
                console.log(widg[0]?.data?.spaces);
                console.log(widg[0]?.data?.content);
                const as = <MODALS.StpRegister 
                    data={widg[0]?.data}
                    pos={props.pos}
                    changeAlert={props.changeAlert}
                    changeLoader={props.changeLoader}
                    config={widg[0]?.config}
                    key="stpRegister" />
                openlightbox(as);
            }
        }

        props.changeLoader(false);
    };

    return <div style={{ width: "96%", margin: "auto" }}>
        <ThemeProvider theme={theme}>
            <DataTable columns={columns} data={data} customStyles={customStyles} noDataComponent={noDataComponent}/>
        </ThemeProvider>
    </div>
};

export default ListStpRegister;
